// extracted by mini-css-extract-plugin
module.exports = {"Image":"AvatarImage_Image__7IFKu","Name":"AvatarImage_Name__c2MXr"};